import { environmentFactory as env } from './environment.base';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const host="https://siprodi.sanidad.gob.es/siprodi-api";
const host_cc="https://siprodi-cc.sanidad.gob.es/siprodi-api";

const production= true;
const mockService=false;
const developing= false;
const debuglevel= 2; // 0 = debug, 1 = info, 2 = warn, 3 = error

export const environment = env(host, host_cc, production, mockService, developing, debuglevel);
